import { Field } from "formik";
import React, { Fragment, useEffect, useState } from "react";
import EyeCloseIcon from "../../assets/icons/eye-close-icon";
import EyeOpenIcon from "../../assets/icons/eye-open-icon";
import StarIcon from "../../assets/icons/req-star";
import ErrorMsg from "./error-msg";
import "./form.css";
import errorToast from "../helper-components/error-toast";
const escapeForCharClass = (chars) => chars.replace(/[\^\]\\-]/g, "\\$&");

export default function InputField({
  inputClass = "",
  containerClass = "mb-2 position-relative",
  parentClass = "flex items-center m-0 p-0 w-full",
  labelClass = "whitespace-nowrap flex text-[var(--input-label-color)] text-[length:var(--input-label-font-size)] font-[var(--input-label-font-weight)]",
  defaultInputClass = "min-h-[42px] rounded-[8px]  px-2  bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--input-font-weight)] rounded input-field-no-spin-buttons placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:border-[var(--input-focus)] focus:text-[var(--input-color)] focus:bg-[var(--input-bg)] ",
  errorBorder = "border border-[var(--input-error-border)]",
  inputBorder = "border border-[var(--input-border)]",
  max = "",
  min = 0,
  isDisabled = false,
  name = "",
  placeholder = "Enter your email address",
  label = "Email Address",
  id,
  type = "text",
  errMsgContainerClass = "",
  isContainer = true,
  isUnit = false,
  unitType = localStorage?.getItem("currency") ?? "₹",
  unitPosition = "left",
  isPasswordEye = false,
  passwordEyeStyle = { top: "44%" },
  autoComplete = "",
  unitClassName = "",
  children,
  isRequired = false,
  labelWidth = "10rem",
  prefixicon = "",
  allowSpecial = false,
  extraAllowedChars = "",
  onlyNums = false,
  maxValue,
  handleChange = (e, field) => {
    field.onChange(e);
  },

  autoFocus = false,
  maxLength = 1000,
  // Passed to the input as-is; "any" lets a number field take any decimal
  step,
  onKeyDown = (event) => {
    if (event.ctrlKey || event.metaKey || event.altKey) return;
    // Ignore non-character keys (Shift, CapsLock, Alt, Backspace, Tab, Enter,
    // arrows, Home/End, F1-F12, etc.) — they all report a multi-char event.key
    // and should never trigger the special-character toast.
    if (event.key.length > 1) return;

    // "float" and "number" fields are decimal fields, so "." is part of their
    // alphabet — otherwise the special-character guard below strips it and
    // 10.5 becomes 105.
    const isDecimalField = type === "float" || type === "number";
    const extraClass = escapeForCharClass(
      isDecimalField ? `${extraAllowedChars}.` : extraAllowedChars
    );

    // One decimal point only. A second "." makes a number input report an empty
    // value, which reads as the field wiping itself, so block it quietly — it is
    // not a special character and does not deserve the toast.
    if (
      !allowSpecial &&
      isDecimalField &&
      event.key === "." &&
      String(event.target?.value ?? "").includes(".")
    ) {
      event.preventDefault();
      return;
    }
    const validKey =
      type === "text" && onlyNums
        ? /^[0-9]$/
        : new RegExp(`^[a-zA-Z0-9\\s${extraClass}]$`);

    if (!allowSpecial && !validKey.test(event.key)) {
      event.preventDefault();
      errorToast("Special Characters are blocked");
    }

    if (!allowSpecial && type === "number" && (event.key === "-" || event.key === "e")) {
      event.preventDefault();
      errorToast("Special Characters are blocked");
    }
  },

  onBlur,
  unitContainerClass = "flex unit_input__container",
  unitContainerErrorClass = "flex unit_input_container__error",
  passwordEyeClass = "position-absolute  end-0 translate-middle  cursor_pointer",
  inputRef,

  // 👉 NEW: right icon (React component/element)
  rightIcon = null,
  rightIconClass = "absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer flex items-center",
  rightIconStyle = {},
}) {
  const finalInputClass = inputClass
    ? `${defaultInputClass} ${inputClass}`
    : defaultInputClass;

  const Container = isContainer ? "div" : Fragment;
  const UnitContainer = isUnit ? "div" : Fragment;
  const PasswordEyeContainer = isPasswordEye || rightIcon ? "div" : Fragment;
  const [passInputType, setPassInputType] = useState("password");

  const hasRightAdornment = isPasswordEye || rightIcon;

  useEffect(() => {
    if (autoFocus) {
      if (inputRef?.current) {
        inputRef?.current?.focus();
      }
    }
  }, []);

  return (
    <Container
      {...(isContainer && containerClass ? { className: containerClass } : {})}
    >
      <Field className="no-arrows" name={name}>
        {({ field, meta }) => (
          <div className={parentClass}>
            {label && (
              <label
                style={{
                  minWidth: labelWidth,
                }}
                {...(id ? { htmlFor: id } : {})}
                className={`${labelClass} flex  flex-nowrap`}
              >
                <span className="flex items-center gap-2">
                  {prefixicon}
                  {label}
                </span>
                {isRequired && (
                  <span className="ml-2">
                    <StarIcon />
                  </span>
                )}
              </label>
            )}
            <UnitContainer
              {...(unitContainerClass && isUnit
                ? {
                  className: `  ${meta.touched && meta.error
                      ? unitContainerErrorClass
                      : unitContainerClass
                    } ${unitPosition === "right" ? "flex-row-reverse" : ""
                    } w-full`,
                }
                : {})}
            >
              {isUnit && (
                <div
                  className={`d-flex justify-content-center align-items-center font_poppins mt-1 ${unitPosition === "right" ? "flex-row-reverse" : ""
                    }`}
                >
                  <span
                    className={` fw_500 text-sm align-middle primary_color ${unitClassName} ${unitPosition === "right" ? "ms-1" : "me-1"
                      }`}
                  >
                    {unitType}
                  </span>{" "}
                  {unitPosition !== "image" && (
                    <span className={`input-vr mx-2`}></span>
                  )}
                </div>
              )}
              <PasswordEyeContainer
                {...(isPasswordEye || rightIcon
                  ? {
                    className: `position-relative relative w-full`,
                  }
                  : {})}
              >
                <input
                  min={min}
                  max={max}
                  {...(step !== undefined ? { step } : {})}
                  maxLength={maxLength}
                  onWheel={(e) => e.target.blur()}
                  ref={inputRef}
                  {...(isDisabled ? { disabled: true } : {})}
                  {...(autoComplete ? { autoComplete: autoComplete } : {})}
                  type={type === "password" ? passInputType : type}
                  {...field}
                  placeholder={placeholder}
                  {...(id ? { id: id } : {})}
                  className={`${isUnit
                      ? `${finalInputClass} focus_outline__none w-100 ${hasRightAdornment ? "pr-10" : ""
                      }`
                      : `${meta.touched && meta.error ? errorBorder : inputBorder
                      } ${autoFocus
                        ? "focus:border-focus-color border"
                        : "no-arrows"
                      } ${finalInputClass} input-field-no-spin-buttons w-full ${hasRightAdornment ? "pr-10" : ""
                      }`
                    } ${isDisabled
                      ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                      : ""
                    }`}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (
                      type === "number" &&
                      typeof maxValue === "number" &&
                      maxValue > 0
                    ) {
                      const numericValue = parseFloat(value);
                      if (!isNaN(numericValue) && numericValue > maxValue) {
                        errorToast(`Max value is ${maxValue}`)
                        return;
                      }
                    }

                    if (value.length <= maxLength) {
                      handleChange(e, field);
                      field.onChange(e);
                    }
                  }}
                  onBlur={onBlur}
                  onKeyDown={onKeyDown}
                  onPaste={(e) => {
                    if (allowSpecial) return;
                    const pasted = e.clipboardData.getData("text");
                    // Same as the keydown guard: "." belongs to a decimal field.
                    const extraClass = escapeForCharClass(
                      type === "float" || type === "number"
                        ? `${extraAllowedChars}.`
                        : extraAllowedChars
                    );
                    const invalid =
                      type === "text" && onlyNums
                        ? /[^0-9]/
                        : new RegExp(`[^a-zA-Z0-9\\s${extraClass}]`);
                    // No special characters in the pasted text → allow normal paste
                    if (!invalid.test(pasted)) return;

                    e.preventDefault();
                    errorToast("Special Characters are blocked");

                    // Strip the disallowed characters and insert the cleaned text
                    const stripPattern =
                      type === "text" && onlyNums
                        ? /[^0-9]/g
                        : new RegExp(`[^a-zA-Z0-9\\s${extraClass}]`, "g");
                    const cleaned = pasted.replace(stripPattern, "");
                    const input = e.target;
                    const start = input.selectionStart ?? input.value.length;
                    const end = input.selectionEnd ?? input.value.length;
                    const newValue = (
                      input.value.slice(0, start) +
                      cleaned +
                      input.value.slice(end)
                    ).slice(0, maxLength);
                    field.onChange({ target: { name, value: newValue } });
                  }}
                />

                {/* Password eye (unchanged) */}
                {isPasswordEye &&
                  (passInputType === "password" ? (
                    <button
                      style={passwordEyeStyle}
                      type="button"
                      className={`${passwordEyeClass} `}
                    >
                      <EyeCloseIcon onClick={() => setPassInputType("text")} />
                    </button>
                  ) : (
                    <button
                      type="button"
                      style={passwordEyeStyle}
                      className={`${passwordEyeClass} border-0`}
                    >
                      <EyeOpenIcon
                        onClick={() => setPassInputType("password")}
                      />
                    </button>
                  ))}
                {rightIcon && (
                  <div style={rightIconStyle} className={rightIconClass}>
                    {rightIcon}
                  </div>
                )}
              </PasswordEyeContainer>
            </UnitContainer>
          </div>
        )}
      </Field>
      <ErrorMsg containerClass={errMsgContainerClass} name={name} />
      {children}
    </Container>
  );
}
